<form [formGroup]="form" autocomplete="off">
    <div *ngFor="let control of (observable | async); let i = index; trackBy: trackByName"
         [ngClass]="{ 'removable-input': control.removable }">
        <ng-container *ngIf="!control.hidden">
            <a
                *ngIf="control.removable"

                (click)="removeControl(i)"

                href="javascript:void(0);"
                class="icon-action-btn"
            >
                <i class="fa fa-minus-circle fa-sm text-danger"></i>
            </a>
            <div [ngSwitch]="control.componentType">
                <app-select
                    *ngSwitchCase="componentTypes.Select"
                    [formControlName]="control.name"
                    [control]="control"
                ></app-select>
                <ng-container *ngSwitchCase="componentTypes.RadioGroup">
                    <label id="radio" class="small mb-0 mt-1 text-black-50">{{control.placeholder}}</label>
                    <app-radio-group
                        [formControlName]="control.name"
                        [control]="control"
                    ></app-radio-group>
                </ng-container>
                <app-autocomplete
                    *ngSwitchCase="componentTypes.Autocomplete"
                    [formControlName]="control.name"
                    [control]="control"
                ></app-autocomplete>
                <app-phone-autocomplete
                    *ngSwitchCase="componentTypes.PhoneAutocomplete"
                    [formControlName]="control.name"
                    [control]="control"
                ></app-phone-autocomplete>
                <app-datepicker
                    *ngSwitchCase="componentTypes.Datepicker"
                    [formControlName]="control.name"
                    [control]="control"
                ></app-datepicker>
                <app-country-autocomplete
                    *ngSwitchCase="componentTypes.CountryAutocomplete"
                    [formControlName]="control.name"
                    [control]="control"
                ></app-country-autocomplete>
                <app-lockable-datepicker
                    *ngSwitchCase="componentTypes.LockableDatepicker"
                    [formControlName]="control.name"
                    [control]="control"
                    [leftAligned]="true"
                ></app-lockable-datepicker>
                <app-password-input
                    *ngSwitchCase="componentTypes.Password"
                    [formControlName]="control.name"
                    [control]="control"
                ></app-password-input>
                <app-checkbox
                    *ngSwitchCase="componentTypes.Checkbox"
                    [formControlName]="control.name"
                    [control]="control"
                >
                    <ng-container text>{{control.placeholder}}</ng-container>
                </app-checkbox>
                <app-add-new-select
                    *ngSwitchCase="componentTypes.AddNewSelect"
                    [formControlName]="control.name"
                    [control]="control"
                ></app-add-new-select>
                <app-panel-input
                    *ngSwitchDefault
                    [formControlName]="control.name"
                    [control]="control"
                ></app-panel-input>
            </div>
        </ng-container>
    </div>
    <div *ngIf="!hiddenActions" class="text-right">
        <button type="submit" class="btn btn-sm btn-outline-primary mr-3">Cancel</button>
        <button type="submit" class="btn btn-sm btn-primary">Submit</button>
    </div>
</form>
